import type { DocumentPipController } from './DocumentPipController';
import type { RecorderController } from './RecorderController';

/**
 * Starts both activation-gated browser operations in one click stack. The
 * recorder synchronously requests display capture before its first await.
 */
export function startRecorderWithFloatingControl(
  recorder: RecorderController,
  pip: DocumentPipController,
  input: Parameters<RecorderController['start']>[0],
): void {
  pip.setActive(true);
  void recorder.start(input);
  void pip.open();
}
